import type {MouseEventHandler} from 'react';
import type {ButtonProps} from '@Components/button';
import {ControlledListItemTypeButton} from '@Components/controlled-list/components/controlled-list-item-type-button';
import {useAppSelector} from '../../../../hooks';
import type {ListDefaultItemBaseStorage} from '../../list.types';

interface ListItemTypeButtonProps {
  id: string;
  listId: string;
  onClick?: MouseEventHandler | (() => Promise<any>);
}

export interface ListItemTypeButtonStorage extends ListDefaultItemBaseStorage {
  buttonProps: ButtonProps;
}

export function ListItemTypeButton({...props}: ListItemTypeButtonProps) {
  const listButtonData = useAppSelector((state) => {
    return state.list.listItemData.listItemsHashMap[props.id] as ListItemTypeButtonStorage;
  });

  return <ControlledListItemTypeButton isSelected={false} text="" buttonProps={{...listButtonData.buttonProps, onClick: props.onClick}} id={props.id} />;
}
